<template>
    <div :class="['message-box', { error: type == 'error' }]" v-if="show">
        <b-icon
            :icon="icons[type]"
            :type="`is-${type}`"
            size="is-medium"
        ></b-icon>
        <p class="message-area">{{ message }}</p>
        <div class="close" @click="show = false">
            <i class="mdi mdi-close"></i>
        </div>
    </div>
</template>
<script>
import { globalEvent } from "@/main";

export default {
    data() {
        return {
            show: false,
            message: "",
            type: "info", //could be error, success or info
            icons: {
                error: "alert-outline",
                success: "check-bold",
                info: "information-variant",
            },
        };
    },
    watch: {
        show: {
            immediate: true,
            handler(val) {
                if (!val) return;
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            },
        },
    },
    created() {
        setTimeout(() => {
            this.showMSG = false;
        }, 10000);
        globalEvent.$on("message", (d) => {
            this.show = true;
            this.type = d.type;
            this.message = d.message;
            globalEvent.$emit("haveErrors");
        });

        globalEvent.$on("renewError", () => {
            this.show = false;
        });
    },
};
</script>
<style lang="scss" scoped>
.error {
    background: #ff797740 !important;
}
.message-box {
    position: relative;
    margin: 2px 20px -35px 20px;
    padding: 10px 15px;
    background-color: #4952ff30;
    box-shadow: 0 8px 15px 0 rgba(217, 217, 217, 0.3);
    border-radius: 15px;

    .icon {
        position: absolute;
        top: 6px;
    }

    .message-area {
        display: inline-block;
        width: 80%;
        margin-left: 45px;
    }

    .mdi {
        border-radius: 50%;
        position: absolute;
        top: 20%;
        padding: 0 5px;
        transition: 0.3s;

        &:hover {
            background: #ddd;
            cursor: pointer;
        }
    }
}
</style>
